// --------------------------------------------------------------------------
// #143 Disable form field
//     - If one form field has a value then a related field is disabled
//	   - Only works on a one-to-one basis, and only one way (i.e. not
//	     reciprocal).
// 	   - [data-behavior="disable-field"] is added to an element which
//	     contains both fields.
//	   - [data-disable-field="will-disable"] is applied to the field which will
//	     do the disabling.
//	   - [data-disable-field="is-disabled"] is applied to the field which will
//	     be disabled.
//	   - Supported field types: text, file, select, checkbox
// --------------------------------------------------------------------------
// Authors:     Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;
	var willDisable = context.find('[data-disable-field="will-disable"]');
	var willDisableType = willDisable.prop('type');
	var isDisabled = context.find('[data-disable-field="is-disabled"]');
	var isDisabledType = isDisabled.prop('type');
	var isDisabledId = isDisabled.attr('id');
	var isDisabledLabel = context.find('label[for="' + isDisabledId + '"]');

	function disableField() {
		willDisable.on('change', function () {
			var field = $(this);
			var hasValue;

			if (willDisableType !== 'checkbox' && field.val() !== '') {
				hasValue = true;
			} else if (willDisableType === 'checkbox' && field.is('checked')) {
				hasValue = true;
			} else {
				hasValue = false;
			}

			if (hasValue === true) {

				if (isDisabledType !== 'checkbox') {
					isDisabled.val('').prop('disabled', true);
				} else {
					isDisabled.prop('checked', false).prop('disabled', true);
				}

				isDisabled.addClass('input-is-disabled');
				isDisabledLabel.addClass('label-is-disabled');
			} else {

				if (isDisabledType !== 'checkbox') {
					isDisabled.prop('disabled', false);
				} else {
					isDisabled.prop('disabled', false);
				}

				isDisabled.removeClass('input-is-disabled');
				isDisabledLabel.removeClass('label-is-disabled');
			}
		});
	}

	function init() {
		disableField();
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/disable-field.js
// module id = 257
// module chunks = 0